<div class="flex-column gap p-2">
    <div class="flex gap-small">
        <app-date-input
            [form]="form"
            class="flex-1"
            id="date"
            [label]="prefix + 'fields.date'"
        ></app-date-input>
        <app-select-input
            [staticOptions]="placeOptions"
            [form]="form"
            class="flex-1"
            id="place"
            [showClear]="false"
            [autoDisplayFirst]="true"
            [label]="prefix + 'fields.placeFields.label'"
            valueKey="value"
        ></app-select-input>
    </div>
    <app-input-wysiwyg
        [form]="form"
        id="assessment"
        editorKey="NursingCareAssessmentDialogAssessment"
        [autocompleteOrganization]="true"
    ></app-input-wysiwyg>
    <div class="flex flex-1 gap">
        <app-button
            class="flex-1"
            styleClass="w-full"
            [label]="prefix + 'addMeasuring'"
            [loading]="addMeassuringLoading"
            (clickEvent)="addMeasuring()"
        ></app-button>
        <app-button
            class="flex-1"
            styleClass="w-full"
            [label]="prefix + 'addInputSummary'"
            [loading]="addInputSummaryLoading"
            (clickEvent)="addInputSummary()"
        ></app-button>
    </div>
    <app-text-area-input
        [form]="form"
        id="peoplePresent"
        [label]="prefix + 'fields.peoplePresent'"
    ></app-text-area-input>
    <app-multi-select-input
        #multiselect
        [form]="form"
        id="assessedBy"
        valueKey="id"
        labelKey="id"
        [infiniteScroll]="userScroll()"
        [label]="prefix + 'fields.assessedBy'"
        [zIndex]="10005"
    >
        <ng-template #item let-item>
            <div class="flex-column gap-xx-small">
                <div>{{ item | formatPerson }}</div>
                @if (item.name?.length) {
                    <div class="font-size-x-small text-secondary">{{ item.email }}</div>
                }
            </div>
        </ng-template>
        <ng-template #selectedItems let-items>
            <div class="flex gap-small" style="min-height: 1.25rem;">
                @for (item of items; track $index) {
                    <app-user-chip [user]="item" [renderType]="1"></app-user-chip>
                }
            </div>
        </ng-template>
    </app-multi-select-input>
</div>
